import { Toast } from '@easyvaas/js-components';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import SmallText from 'src/components/SmallText';
import {
  additionsListSelector,
  materialItemSelector
} from 'src/modules/imagesV3/store/selector';
import {
  evolutionAdditionsState,
  evolutionProbState,
  imagePopupState
} from 'src/modules/imagesV3/store/state';
import styles from './index.module.scss';

interface CandidateItemProps {
  id: number;
  onClick: (v: ImageV3API.Material) => any;
  type: number;
}
const CandidateItem = ({ id, onClick, type }: CandidateItemProps) => {
  const item = useRecoilValue(materialItemSelector(id));
  if (!item) return null;
  const requirement = (() => {
    if (type > 1) return 1;
    return item.specialExtend?.piecesType === 0 ? 5 : 2000;
  })();
  return (
    <div
      className={styles.item}
      onClick={() => {
        if (requirement > item.number) {
          Toast(`${item.title}不足`);
          return;
        }
        onClick(item);
      }}
    >
      <img src={item.logo} alt="" />
      {type > 1 ? (
        <SmallText fontSize={20} inline className={styles.number}>
          {requirement}/{item.number}
        </SmallText>
      ) : (
        <>
          <SmallText fontSize={20} inline className={styles.require}>
            需 {requirement}
          </SmallText>
          <SmallText fontSize={20} inline className={styles.balance}>
            余 {item.number}
          </SmallText>
        </>
      )}
    </div>
  );
};

interface Props {
  type: number;
  index?: number;
}
const AdditionItem: React.FC<Props> = ({ type, index }) => {
  const { visible } = useRecoilValue(imagePopupState('evolution'));
  const [selector, setSelector] = useState(false);
  const [state, setState] = useRecoilState(evolutionAdditionsState);
  const item = useRecoilValue(materialItemSelector(state[index || 0]));
  const setProb = useSetRecoilState(evolutionProbState);
  const placeholder = useMemo(() => {
    switch (type) {
      case 1:
        return '0';
      case 2:
        return '添加进阶卡';
      case 3:
        return '添加磨石';
    }
  }, [type]);
  const candidates = useRecoilValue(additionsListSelector(type));
  const classes = useMemo(() => {
    if (type === 1) return classNames(styles.selector, styles.normal);
    return styles.selector;
  }, [type]);
  const onClick = (v: ImageV3API.Material) => {
    setState(val => {
      const clone = [...val];
      clone[index || 0] =
        v.toolId === 0
          ? 987654320 + (v.specialExtend?.piecesType || 0)
          : v.toolId;
      return clone;
    });
    setProb(prob => {
      if (v.specialExtend && v.specialExtend.successRate) {
        return { ...prob, base: v.specialExtend.successRate };
      }
      if (!item) {
        return { ...prob, extra: Math.min(100 - prob.base, prob.extra + 5) };
      }
      return prob;
    });
  };
  useEffect(() => {
    if (selector) {
      const hanlder = (e: any) => {
        setTimeout(() => {
          setSelector(false);
        });
      };
      document
        .querySelector('#evolution-content')
        ?.addEventListener('click', hanlder);
      return () => {
        document
          .querySelector('#evolution-content')
          ?.removeEventListener('click', hanlder);
      };
    }
  }, [selector]);
  useEffect(() => {
    if (visible) {
      setSelector(false);
      setState([]);
    }
  }, [setState, visible]);
  const renderTitle = () => {
    if (!item) return placeholder || '';
    if (item.toolId !== 0) return item.title;
    if (item.specialExtend?.piecesType === 0) return 5;
    if (item.specialExtend?.piecesType === 100) return 2000;
    return 0;
  };

  return (
    <div className={styles.container}>
      <button
        onClick={() => candidates && setSelector(true)}
        style={
          item
            ? { backgroundImage: `url(${item.logo})`, backgroundSize: '90%' }
            : {}
        }
      />
      <SmallText fontSize={20} className={styles.name} inline>
        {renderTitle()}
      </SmallText>
      {selector && candidates && (
        <div className={classes} id="selector-content">
          {type === 1 && <div className={styles.stitle}>请选择添加道具</div>}
          {candidates &&
            candidates.map(v => (
              <CandidateItem id={v} key={v} onClick={onClick} type={type} />
            ))}
          {type > 1 && <div className={styles.arrow} />}
        </div>
      )}
    </div>
  );
};

export default React.memo(AdditionItem);
